import React from "react";
import { Loader2 } from "lucide-react";
import clsx from "clsx";

export const Spinner: React.FC<{ size?: number; className?: string }> = ({
  size = 18,
  className,
}) => <Loader2 size={size} className={clsx("animate-spin", className)} />;
